import React from 'react';
import { ChevronDown } from 'lucide-react';
interface SegmentOption {
  id: string;
  label: string;
  icon?: ReactNode;
}
interface SegmentDropdownProps {
  label: string;
  options: SegmentOption[];
  value: string;
  onChange: (value: string) => void;
  className?: string;
}
export const SegmentDropdown: React.FC<SegmentDropdownProps> = ({
  label,
  options,
  value,
  onChange,
  className = ''
}) => {
  return <div className={`relative ${className}`} data-id="element-14550">
      {label && <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1" data-id="element-14551">
          {label}
        </label>}
      <div className="relative" data-id="element-14552">
        <select value={value} onChange={e => onChange(e.target.value)} className="block w-full pl-3 pr-10 py-2 text-sm border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-800 rounded-md focus:outline-none focus:ring-purple-500 focus:border-purple-500 dark:focus:ring-purple-400 dark:focus:border-purple-400" data-id="element-14553">
          {options.map(option => <option key={option.id} value={option.id} data-id="element-14554">
              {option.label}
            </option>)}
        </select>
        <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none" data-id="element-14555">
          <ChevronDown size={16} className="text-gray-500 dark:text-gray-400" data-id="element-14556" />
        </div>
      </div>
    </div>;
};